import { v4 } from 'uuid';

window.uuid = window.uuid || {};
window.uuid.v4 = v4;
